import { render } from "./AppVersionSetting.vue?vue&type=template&id=9dba6862"
import script from "./AppVersionSetting.vue?vue&type=script&lang=js"
export * from "./AppVersionSetting.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__